import { createStore } from '@vfde-sails/core';
import landingPage from 'Container/Landingpage';

import './style.scss';
import { trackingMiddleware } from '@vfde-sails/tracking';

createStore({}, [trackingMiddleware]);

landingPage();
